// Shared constants between react-select dropdowns
import { components, createFilter } from "react-select";
import {
  countriesOptions,
  currencyOptions,
  dialCodeOptions,
  experienceLevelOptions,
  experienceOptions,
  nmbOfEmplOptions,
  periodOptions,
  talentSkillsOptions,
  talentRoleOptions
} from "./Options";

interface IClassNamesProps {
  controlClassName?: string;
  isMulti?: boolean;
}

// Base styles
export const _classNames = ({ controlClassName, isMulti }: IClassNamesProps) => ({
  control: () =>
    ` px-1 ${isMulti ? "!min-h-[48px] h-fit" : "h-[48px]"} !rounded-[8px] !border-dark-gray !font-poppins text-sm ${controlClassName}`,
  indicatorSeparator: () => "hidden",
  dropdownIndicator: () => " !pl-0",
  singleValue: () => " !text-clip ",
  option: () => "  hover:bg-[#D9D9FF]"
});

const OptimizedOption = (props) => {
  const { innerProps, children } = props;

  // With lists longer than 1000 items, the performance is not good.
  // Remove unnecessary event handlers to optimize performance
  const customInnerProps = { ...innerProps };
  delete customInnerProps.onMouseMove;
  delete customInnerProps.onMouseOver;

  return (
    <components.Option {...props} innerProps={customInnerProps}>
      {children}
    </components.Option>
  );
};

// Meta
export const _components = {
  Option: OptimizedOption
};
// This improves performance of typing search for long lists
export const _filterOption = createFilter({ ignoreAccents: false });

// Some default options
export type Options =
  | "countries"
  | "number_of_employees"
  | "dial_codes"
  | "experiences"
  | "periods"
  | "currencies"
  | "experience_levels"
  | "talent_skills"
  | "talent_roles";

export const OPTIONS: { [key in Options]: typeof countriesOptions } = {
  countries: countriesOptions,
  number_of_employees: nmbOfEmplOptions,
  dial_codes: dialCodeOptions,
  experiences: experienceOptions,
  periods: periodOptions,
  currencies: currencyOptions,
  experience_levels: experienceLevelOptions,
  talent_skills: talentSkillsOptions,
  talent_roles: talentRoleOptions
};

// Common reusable creation labels
export const _formatCreateLabel = {
  filtering: (label) => `Filter by "${label}"`
};
